import {
  lightTextPlaceholder,
  medGrey,
  lightSurface2,
  lightNeutral50,
  darkTextPlaceholder,
} from "constants/colors";
import { BREAKPOINT_DESKTOP } from "constants/constants";
import styled, { css } from "styled-components/macro";

export const ClockDataCellStyles = styled.div<{
  $isCurrent: boolean;
  $isSizeSmall: boolean;
  $isFutureRange: boolean;
  $outputLossTextColor: string;
  $buttonBackgroundColor: string;
  $buttonTextColor: string;
  $numOperatorMetrics: number;
}>`
  position: relative;
  font-family: "Roboto";
  font-style: normal;
  font-size: 20px;
  line-height: 20px;
  margin: 0 ${props => (props.$isSizeSmall ? 3 : 10)}px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.02em;
  padding: 4px;
  border-radius: 8px;
  .metric-outputLossSum {
    color: ${props =>
      props.$isFutureRange ? lightTextPlaceholder : props.$outputLossTextColor};
    font-size: 22px;
    line-height: 30px;
    padding-top: 12px;
    font-weight: bold;
  }
  .metric-teamSize {
    padding-top: 12px;
    height: 42px;
    box-sizing: border-box;
  }

  .metric-netOutput,
  .metric-totalPotentialOutput {
    font-size: 20px;
    line-height: 24px;
  }
  .metric:nth-child(2) {
    margin-top: 8px;
  }

  .metric-totalPotentialOutput {
    color: ${lightTextPlaceholder};
  }
  .MuiButton-root {
    font-weight: bold;
    pointer-events: none;
    box-shadow: none;
    padding: 0 8px;
    font-family: "Open Sans";
    font-style: normal;
    font-size: 20px;
    border: 1px solid
      ${props =>
        props.$buttonBackgroundColor === "white"
          ? medGrey
          : props.$buttonBackgroundColor};
    background-color: ${props => props.$buttonBackgroundColor};
    color: ${props => props.$buttonTextColor};
    &:hover {
      background-color: ${props => props.$buttonBackgroundColor};
      box-shadow: none;
    }
  }
  ${props =>
    props.$isCurrent
      ? css`
          padding-bottom: 4px;
          @media (max-width: ${BREAKPOINT_DESKTOP}px) {
            padding-bottom: 18px;
          }
          background: ${lightSurface2};
          .MuiButton-root {
            border: 1px solid ${lightNeutral50};
          }
          .metric-teamSize {
            margin-top: 2px;
          }
          .currentIndicator {
            color: ${darkTextPlaceholder};
            font-size: 16px;
            line-height: 22px;
            padding-top: 10px;
          }
        `
      : css`
          .metric-teamSize {
            margin-top: 1px;
          }
        `}
`;
